module.exports = require("swa-bootstrap-corporate-landing-home-page/currency-settings");